module.exports = {
	"rasa_nlu_data": {
		"common_examples": [
			{
				"text": "hey",
				"intent": "greet",
				"entities": []
			},
			{
				"text": "howdy",
				"intent": "greet",
				"entities": []
			},
			{
				"text": "hey there",
				"intent": "greet",
				"entities": []
			},
			{
				"text": "hello",
				"intent": "greet",
				"entities": []
			},
			{
				"text": "hi",
				"intent": "greet",
				"entities": []
			},
			{
				"text": "i'm looking for a place to eat",
				"intent": "restaurant_search",
				"entities": []
			},
			{
				"text": "i'm looking for a place in the north of town",
				"intent": "restaurant_search",
				"entities": [
					{
						"start": 31,
						"end": 36,
						"value": "north",
						"entity": "location"
					}
				]
			},
			{
				"text": "show me chinese restaurants",
				"intent": "restaurant_search",
				"entities": [
					{
						"start": 8,
						"end": 15,
						"value": "chinese",
						"entity": "cuisine"
					}
				]
			},
			{
				"text": "yes",
				"intent": "affirm",
				"entities": []
			},
			{
				"text": "yep",
				"intent": "affirm",
				"entities": []
			},
			{
				"text": "yeah",
				"intent": "affirm",
				"entities": []
			},
			{
				"text": "show me a mexican place in the centre",
				"intent": "restaurant_search",
				"entities": [
					{
						"start": 31,
						"end": 37,
						"value": "centre",
						"entity": "location"
					},
					{
						"start": 10,
						"end": 17,
						"value": "mexican",
						"entity": "cuisine"
					}
				]
			},
			{
				"text": "bye",
				"intent": "goodbye",
				"entities": []
			},
			{
				"text": "goodbye",
				"intent": "goodbye",
				"entities": []
			},
			{
				"text": "good bye",
				"intent": "goodbye",
				"entities": []
			},
			{
				"text": "stop",
				"intent": "goodbye",
				"entities": []
			},
			{
				"text": "end",
				"intent": "goodbye",
				"entities": []
			},
			{
				"text": "i am looking for an indian spot",
				"intent": "restaurant_search",
				"entities": [
					{
						"start": 20,
						"end": 26,
						"value": "indian",
						"entity": "cuisine"
					}
				]
			},
			{
				"text": "search for restaurants",
				"intent": "restaurant_search",
				"entities": []
			},
			{
				"text": "anywhere in the west",
				"intent": "restaurant_search",
				"entities": [
					{
						"start": 16,
						"end": 20,
						"value": "west",
						"entity": "location"
					}
				]
			},
			{
				"text": "central indian restaurant",
				"intent": "restaurant_search",
				"entities": [
					{
						"start": 0,
						"end": 7,
						"value": "central",
						"entity": "location"
					},
					{
						"start": 8,
						"end": 14,
						"value": "indian",
						"entity": "cuisine"
					}
				]
			},
			{
				"text": "indeed",
				"intent": "affirm",
				"entities": []
			},
			{
				"text": "that's right",
				"intent": "affirm",
				"entities": []
			},
			{
				"text": "ok",
				"intent": "affirm",
				"entities": []
			},
			{
				"text": "great",
				"intent": "affirm",
				"entities": []
			}
		]
	}
};


//////////////////
// WEBPACK FOOTER
// ./src/state/testData.json
// module id = 539
// module chunks = 0